import { useMemo } from 'react'
import { useTimeZone } from '@sweetspot/sweetspot-js/common/react-query/hooks/useTimeZone'
import { RawTimezone, Timezone } from '../types'

export const useFormattedTimezones = () => {
  const { timezones } = useTimeZone<RawTimezone[]>()

  const formattedTimezones = useMemo<Timezone[]>(() => {
    if (timezones) {
      return timezones.map((zone) => {
        const offset = Math.floor(zone.offset / 3600)
        const offsetString = offset > 0 ? `+${offset}` : offset
        return {
          id: zone.timezone_id,
          name: `(UTC ${offsetString}) ${zone.timezone_id}`,
          ...zone,
        }
      })
    }
    return []
  }, [timezones])

  const userTimezone = useMemo<Timezone | null>(() => {
    const userTz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (formattedTimezones.length && userTz) {
      return formattedTimezones.find((tz) => tz.timezone_id === userTz) || null
    }
    return null
  }, [formattedTimezones])

  return {
    formattedTimezones,
    userTimezone,
  }
}
